import {
  API_TYPES,
  SITE_DOMAINS,
  LOCAL_STORAGE_KEYS,
  WIDGET_TYPES,
  TERMINATOR,
  AD_DISPLAYS, SEO_PROMOTION_LINKS, BETTING_ZONE_API_TYPES,
  ENVIRONMENTS,
} from "../consts";
import {CoralogixRum} from '@coralogix/browser';
import {initCoralogix} from '../../coralogix-integration';

import {SiteConfig} from "./models/site-config";
import {BootstrapSettings} from "./models/bootstrap-settings";
import {BootstrapModuleConfig} from './bootstrap-module.config';
import {ResolutionUtils} from "../../infrastructure/utils/resolution-utils";
import {IOC} from "../../infrastructure/ioc";
import {BaseService} from "../../infrastructure/domain-services/base-service";
import {DomUtils} from "../../infrastructure/utils/dom-utils";
import {BaseProps} from "../../infrastructure/models/props/base-props";
import {PublisherApiModel} from "../../domain/publisher/models/publisher.api-model";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";

import {configure} from "mobx";
import {ARGS} from "./args";
import {CookieManager} from "../managers/cookie-manager";

if (ARGS.PRODUCTION_TYPE !== 'production') {
  configure({
    // enforceActions: "always",
    // computedRequiresReaction: true,
    // reactionRequiresObservable: true,
    // observableRequiresReaction: true,
    // disableErrorBoundaries: true
  })
}

export class BootstrapModuleController extends BaseService {
  settings: BootstrapSettings;
  config: BootstrapModuleConfig;
  ioc: IOC;
  props: BaseProps;

  constructor(props) {
    super();

    this.props = props;
    this.ioc = props.ioc;
    this.init(props);
  }

  init(props) {
    const bootstrapParams: BootstrapSettings = new BootstrapSettings(props);
    this.settings = bootstrapParams;

    this.initDomContainer(props.rootElement);

    this.ioc.registerSingleton(BootstrapSettings, bootstrapParams);

    this.createSiteConfig(bootstrapParams);
    initCoralogix();
    this.createUserPartitionKey();
  }

  createSiteConfig(params): SiteConfig {
    const partnerModel = new PublisherApiModel(0, '365Scores', 'default', SITE_DOMAINS.default);
    const localStorageUtils: LocalStorageUtils = this.ioc.getInstance(LocalStorageUtils);

    const config: SiteConfig = this.ioc.getInstance(SiteConfig);
    const storageApiType = localStorageUtils.get(LOCAL_STORAGE_KEYS.apiType);
    const terminatorEnvType = localStorageUtils.get(LOCAL_STORAGE_KEYS.terminatorEnvType) || TERMINATOR.ENV_TYPES.prod;
    const splEnvType = localStorageUtils.get(LOCAL_STORAGE_KEYS.splEnvType) || SEO_PROMOTION_LINKS.ENV_TYPES.prod;
    const adDisplay: API_TYPES = localStorageUtils.get(LOCAL_STORAGE_KEYS.adDisplays) || AD_DISPLAYS.default;
    const apiType: API_TYPES = this._resolveApiType(params, storageApiType);
    const bettingZoneApi: String = localStorageUtils.get(LOCAL_STORAGE_KEYS.bettingZoneApiType) || BETTING_ZONE_API_TYPES.prod;

    config.init(params, partnerModel, apiType, terminatorEnvType, splEnvType, adDisplay, bettingZoneApi);

    this.config = config;

    return config;
  }

  createUserPartitionKey() {
    const localStorageUtils: LocalStorageUtils = this.ioc.getInstance(LocalStorageUtils);
    const cookieManager: CookieManager = this.ioc.getInstance(CookieManager);
    let partitionKey = localStorageUtils.get(LOCAL_STORAGE_KEYS.kinesisPartitionKey);

    if (!partitionKey) {
      partitionKey = Math.random().toString(36);

      localStorageUtils.set(LOCAL_STORAGE_KEYS.kinesisPartitionKey, partitionKey);
    }

    cookieManager.updateCookieUserId(partitionKey)

    CoralogixRum.setUserContext({
      user_id: partitionKey,
    })
  }

  _resolveApiType(params: BootstrapSettings, storageApiType: String): String {
    let apiType: String = storageApiType;

    if (!apiType) {
      const isWidget: Boolean = params.widgetType && params.widgetType !== WIDGET_TYPES.website;
      const isDevMode: Boolean = ARGS.NODE_ENV === ENVIRONMENTS.dev;
      const isOnDefaultSite: Boolean = (typeof window !== 'undefined' && window.location.host.includes(SITE_DOMAINS.default)) || isDevMode;
      apiType = params.apiType || (isWidget && !isOnDefaultSite ? API_TYPES.widgets : API_TYPES.webws);
    }

    return apiType;
  }

  initDomContainer(container) {
    const domUtils: DomUtils = this.ioc.getInstance(DomUtils);
    const resolutionUtils: ResolutionUtils = this.ioc.getInstance(ResolutionUtils);
    domUtils.container = container;
    resolutionUtils.applyContainer(container);
  }
}
